import DDUFooterBrakeBias from './components/brake-bias';
import DDUFooterTC from './components/tc';
import DDUFooterABS from './components/abs';
import DDUFooterTC_CUT from './components/tc-cut';
import DDUFooterPitLimiter from './components/pit-limiter';
import DDUFooterFuel from './components/fuel';

function DDUFooter({value, userData}) {
    return (
        <div class="footer-grid grid grid-cols-8 grid-rows-1 gap-4 text-white h-[calc(20%-0.5rem)] w-full">
            <DDUFooterTC value={value}/>
            <DDUFooterTC_CUT value={value}/>
            <DDUFooterABS value={value}/>
            <DDUFooterBrakeBias value={value}/>
            <DDUFooterPitLimiter value={value}/>

            <DDUFooterFuel value={value}/>
        </div>
    );
}

export default DDUFooter;